"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationOpportunityMatchDto = instanceOfOrientationOpportunityMatchDto;
exports.OrientationOpportunityMatchDtoFromJSON = OrientationOpportunityMatchDtoFromJSON;
exports.OrientationOpportunityMatchDtoFromJSONTyped = OrientationOpportunityMatchDtoFromJSONTyped;
exports.OrientationOpportunityMatchDtoToJSON = OrientationOpportunityMatchDtoToJSON;
exports.OrientationOpportunityMatchDtoToJSONTyped = OrientationOpportunityMatchDtoToJSONTyped;
const OrientationOpportunityRequestStatus_1 = require("./OrientationOpportunityRequestStatus");
const ShiftMatchProfileDto_1 = require("./ShiftMatchProfileDto");
const ProfileNameDto_1 = require("./ProfileNameDto");
const OrientationOpportunityMatchType_1 = require("./OrientationOpportunityMatchType");
const RequestedBy_1 = require("./RequestedBy");
/**
 * Check if a given object implements the OrientationOpportunityMatchDto interface.
 */
function instanceOfOrientationOpportunityMatchDto(value) {
    if (!('nurseProfile' in value) || value['nurseProfile'] === undefined)
        return false;
    if (!('matchType' in value) || value['matchType'] === undefined)
        return false;
    return true;
}
function OrientationOpportunityMatchDtoFromJSON(json) {
    return OrientationOpportunityMatchDtoFromJSONTyped(json, false);
}
function OrientationOpportunityMatchDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'nurseProfile': (0, ShiftMatchProfileDto_1.ShiftMatchProfileDtoFromJSON)(json['nurseProfile']),
        'matchType': (0, OrientationOpportunityMatchType_1.OrientationOpportunityMatchTypeFromJSON)(json['matchType']),
        'requestStatus': json['requestStatus'] == null ? undefined : (0, OrientationOpportunityRequestStatus_1.OrientationOpportunityRequestStatusFromJSON)(json['requestStatus']),
        'requestedBy': json['requestedBy'] == null ? undefined : (0, RequestedBy_1.RequestedByFromJSON)(json['requestedBy']),
        'requestedByProfile': json['requestedByProfile'] == null ? undefined : (0, ProfileNameDto_1.ProfileNameDtoFromJSON)(json['requestedByProfile']),
        'message': json['message'] == null ? undefined : json['message'],
        'requestedAt': json['requestedAt'] == null ? undefined : (new Date(json['requestedAt'])),
        'statusUpdatedAt': json['statusUpdatedAt'] == null ? undefined : (new Date(json['statusUpdatedAt'])),
        'declineReason': json['declineReason'] == null ? undefined : json['declineReason'],
        'declinedAt': json['declinedAt'] == null ? undefined : (new Date(json['declinedAt'])),
        'declinedBy': json['declinedBy'] == null ? undefined : (0, ProfileNameDto_1.ProfileNameDtoFromJSON)(json['declinedBy']),
        'notifiedAt': json['notifiedAt'] == null ? undefined : (new Date(json['notifiedAt'])),
        'shiftOfferedAt': json['shiftOfferedAt'] == null ? undefined : (new Date(json['shiftOfferedAt'])),
    };
}
function OrientationOpportunityMatchDtoToJSON(json) {
    return OrientationOpportunityMatchDtoToJSONTyped(json, false);
}
function OrientationOpportunityMatchDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'nurseProfile': (0, ShiftMatchProfileDto_1.ShiftMatchProfileDtoToJSON)(value['nurseProfile']),
        'matchType': (0, OrientationOpportunityMatchType_1.OrientationOpportunityMatchTypeToJSON)(value['matchType']),
        'requestStatus': (0, OrientationOpportunityRequestStatus_1.OrientationOpportunityRequestStatusToJSON)(value['requestStatus']),
        'requestedBy': (0, RequestedBy_1.RequestedByToJSON)(value['requestedBy']),
        'requestedByProfile': (0, ProfileNameDto_1.ProfileNameDtoToJSON)(value['requestedByProfile']),
        'message': value['message'],
        'requestedAt': value['requestedAt'] == null ? undefined : ((value['requestedAt']).toISOString()),
        'statusUpdatedAt': value['statusUpdatedAt'] == null ? undefined : ((value['statusUpdatedAt']).toISOString()),
        'declineReason': value['declineReason'],
        'declinedAt': value['declinedAt'] == null ? undefined : ((value['declinedAt']).toISOString()),
        'declinedBy': (0, ProfileNameDto_1.ProfileNameDtoToJSON)(value['declinedBy']),
        'notifiedAt': value['notifiedAt'] == null ? undefined : ((value['notifiedAt']).toISOString()),
        'shiftOfferedAt': value['shiftOfferedAt'] == null ? undefined : ((value['shiftOfferedAt']).toISOString()),
    };
}
//# sourceMappingURL=OrientationOpportunityMatchDto.js.map